import { useTokenContext } from '../../../context/TokenProvider/TokenProvider';

export const useHasValidTokens = () => {
	const { hasValidAccessToken, hasValidRefreshToken } = useTokenContext();

	const hasValidTokens = hasValidAccessToken && hasValidRefreshToken;

	return { hasValidTokens };
};
